import { MdmPolicyCommand } from "@devices/types";

import { MatchedPolicyRule } from "./RuleCatalog";

export const secretMask = "••••••••";

const isRecord = (entry: unknown): entry is Record<string, unknown> =>
    typeof entry === "object" && entry !== null && !Array.isArray(entry);

/**
 * Masks the value of every field its rule marks `secret`, for the places that show a command verbatim.
 * A command no rule describes is returned unchanged: nothing says which of its keys holds a secret.
 */
export function redactSecrets(command: MdmPolicyCommand, matched: MatchedPolicyRule | null): Record<string, unknown> {
    const secrets = new Set(
        (matched?.rule.fields ?? [])
            .filter((field) => field.type === "text" && field.secret)
            .map((field) => matched?.values[field.name])
            .filter((value): value is string => typeof value === "string" && value !== ""),
    );

    if (secrets.size === 0) {
        return command;
    }

    const maskValue = (entry: unknown): unknown =>
        isRecord(entry) && typeof entry.value === "string" && secrets.has(entry.value) ? { ...entry, value: secretMask } : entry;

    const masked = maskValue(command) as Record<string, unknown>;
    return Array.isArray(masked.subcommands) ? { ...masked, subcommands: masked.subcommands.map(maskValue) } : masked;
}
